import { Location } from 'types/Location';
import { sendAuthorizedRequest, HttpMethod} from './authWrapper';
import { LocationsBaseUrl } from '../properties/appProperties'

export async function getLocations(host: string): Promise<Location[]> {
  
  let locationsUrl = host + LocationsBaseUrl;
  return await sendAuthorizedRequest(HttpMethod.GET, locationsUrl);
}